/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createAccount'

export { $nsid }

/** Create an account. Implemented by PDS. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    email: l.optional(l.string()),
    handle: l.string({ format: 'handle' }),
    did: l.optional(l.string({ format: 'did' })),
    inviteCode: l.optional(l.string()),
    verificationCode: l.optional(l.string()),
    verificationPhone: l.optional(l.string()),
    password: l.optional(l.string()),
    recoveryKey: l.optional(l.string()),
    plcOp: l.optional(l.lexMap()),
  }),
  l.jsonPayload({
    accessJwt: l.string(),
    refreshJwt: l.string(),
    handle: l.string({ format: 'handle' }),
    did: l.string({ format: 'did' }),
    didDoc: l.optional(l.lexMap()),
  }),
  [
    'InvalidHandle',
    'InvalidPassword',
    'InvalidInviteCode',
    'HandleNotAvailable',
    'UnsupportedDomain',
    'UnresolvableDid',
    'IncompatibleDidDoc',
  ],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
